import React, { Fragment, useEffect, useState } from 'react';
import Form from '../../../../components/form/Form';
import Select from '../../../../components/select/Select';
import { connect } from 'react-redux';
import {
  StateModel,
  StateModel_Auftragserfassung,
} from '../../../../redux/store';
import {
  setFrankatur,
  setMetrokennung,
  setSperrigkeit,
  setTerminkennzeichen,
  setVerkehrsart,
} from '../../../../redux/actions/auftragserfassung';
import GridCellWrapper from '../../../../components/grid-cell-wrapper/GridCellWrapper';
import { getTerminkennzeichen } from '../../../../redux/actions/terminkennzeichen';
import { TerminkennzeichenModel } from '../../../../models/TerminkennzeichenModel';
import { FrankaturModel } from '../../../../models/FrankaturModel';
import { getFrankaturen } from '../../../../redux/actions/frankaturen';
import { VerkehrsartModel } from '../../../../models/VerkehrsartModel';
import { getVerkehrsarten } from '../../../../redux/actions/verkehrsarten';
import { getMetrokennungen } from '../../../../redux/actions/metrokennungen';
import { MetrokennungModel } from '../../../../models/MetrokennungModel';
import { UserSessionModel } from '../../../../models/UserSessionModel';
import { SperrigkeitModel } from '../../../../models/SperrigkeitModel';
import { getSperrigkeiten } from '../../../../redux/actions/sperrigkeiten';
import { toSelectOptions } from '../../../../components/select/SelectModel';
import { nameof } from '../../../../utils/objectUtils';
import { Auftrag } from '../../../../api';
import Tauschgeraete from './tauschgeraete/Tauschgeraete';
import {
  resetModalConfig,
  setModalConfig,
} from '../../../../redux/actions/modal';
import SliderCheckbox from '../../../../components/slidercheckbox/SliderCheckbox';
import Zuslademittel from '../zuslademittel/Zuslademittel';
import Modal from '../../../../components/modal/Modal';
import { ZusLademittelModel } from '../../../../models/ZusLademittelModel';
import { ConfigModel } from '../../../../models/ConfigModel';

interface AllgemeinProps {
  resetToggle: boolean;
  auftragserfassung: StateModel_Auftragserfassung;
  setTerminkennzeichen: (value: number | undefined) => void;
  getTerminkennzeichen: () => void;
  terminkennzeichenAuswahlListe: TerminkennzeichenModel[];
  setFrankatur: (value: number | undefined) => void;
  getFrankaturen: (mandantId: number) => void;
  frankaturAuswahlListe: FrankaturModel[];
  setVerkehrsart: (value: number | undefined) => void;
  getVerkehrsarten: (mandantId: number) => void;
  verkehrsartAuswahlListe: VerkehrsartModel[];
  setMetrokennung: (value: number | undefined) => void;
  getMetrokennungen: () => void;
  metrokennungAuswahlListe: MetrokennungModel[];
  userSession: UserSessionModel;
  setSperrigkeit: (value: number | undefined) => void;
  getSperrigkeiten: (mandantId: number) => void;
  sperrigkeitAuswahlListe: SperrigkeitModel[];
  isTauschgeraete: boolean | undefined;
  isZusaetzlicheLademittel: boolean | undefined;
  setModalConfig: (value: any, fieldName: string) => void;
  resetModalConfig: () => void;
  config: ConfigModel;
}

const Allgemein = (props: AllgemeinProps) => {
  const [showModalZusLademittel, setShowModalZusLademittel] = useState(false);
  const isVerkehrsartPflichtfeld = props.config.isVerkehrsartPflichtfeld;
  const showKlassifizierung = props.config.isShowKlassifizierung; //neuer config_param

  useEffect(() => {
    props.getTerminkennzeichen();
    props.getMetrokennungen();
    init();
  }, []);

  useEffect(() => {
    init();
  }, [props.resetToggle]);

  const init = () => {
    props.getFrankaturen(props.auftragserfassung.mandant?.id ?? -1);
    props.getVerkehrsarten(props.auftragserfassung.mandant?.id ?? -1);
    props.getSperrigkeiten(props.auftragserfassung.mandant?.id ?? -1);
  };

  useEffect(() => {
    if (
      props.auftragserfassung.currentAuftragpos.filter(
        item => item.mitGefahrguetern
      ).length > 0 &&
      props.auftragserfassung.terminkennzeichen &&
      props.auftragserfassung.terminkennzeichen >= 50 &&
      props.auftragserfassung.terminkennzeichen <= 52
    ) {
      props.setTerminkennzeichen(undefined);
      createModalMeldungTerminkennzeichen();
    }
  }, [props.auftragserfassung.currentAuftragpos]);

  const setTerminkennzeichenWithCheck = (value: number | undefined) => {
    if (
      value &&
      value >= 50 &&
      value <= 52 &&
      props.auftragserfassung.mitGefahrguetern
    ) {
      value = undefined;
      createModalMeldungTerminkennzeichen();
    }
    props.setTerminkennzeichen(value);
  };

  const createModalMeldungTerminkennzeichen = () => {
    props.resetModalConfig();
    props.setModalConfig('BEX Premium Dienst zurückgesetzt', 'title');
    props.setModalConfig('100px', 'height');
    props.setModalConfig('800px', 'width');
    props.setModalConfig(
      'Der BEX Premium Dienst ist in Verbindung mit Gefahrgut nicht zulässig',
      'description'
    );
    props.setModalConfig(true, 'show');
  };

  const closeZusLademittel = () => {
    setShowModalZusLademittel(false);
  };
  const zusLademittelIsEmpty = (zusLademittel: ZusLademittelModel): boolean => {
    if (zusLademittel === undefined) return true;
    return (
      !zusLademittel.id &&
      !zusLademittel.auftragId &&
      !zusLademittel.lademittel &&
      !zusLademittel.eigentuemer &&
      !zusLademittel.anzFolge &&
      !zusLademittel.anzahl
    );
  };

  return (
    <Fragment>
      <GridCellWrapper classes='allgemein' label='Allgemein'>
        <Form classes='allgemein'>
          <Select
            className='frankatur'
            headerTitle='Frankatur (Rechnung) *'
            name={nameof<Auftrag>('frankatur')}
            onChangeHandler={props.setFrankatur}
            selectedOptionId={props.auftragserfassung.frankatur}
            selectData={toSelectOptions(
              props.frankaturAuswahlListe,
              'kurzBezeichnung',
              false,
              true,
              'langBezeichnung'
            )}
          />
          <Select
            className='verkehrsart'
            name={nameof<Auftrag>('verkehrsart')}
            headerTitle={
              isVerkehrsartPflichtfeld
                ? 'DLA (Verkehrsart) *'
                : 'DLA (Verkehrsart)'
            }
            onChangeHandler={props.setVerkehrsart}
            selectedOptionId={props.auftragserfassung.verkehrsart}
            selectData={toSelectOptions(
              props.verkehrsartAuswahlListe,
              'kurzBezeichnung',
              isVerkehrsartPflichtfeld ? false : true,
              true
            )}
          />
          <Select
            className='terminart'
            headerTitle='Terminart'
            onChangeHandler={setTerminkennzeichenWithCheck}
            selectedOptionId={props.auftragserfassung.terminkennzeichen}
            selectData={toSelectOptions(
              props.terminkennzeichenAuswahlListe,
              'langBezeichnung',
              true,
              true
            )}
            readonly={!!props.auftragserfassung.zustellkennzeichen}
          />
          {showKlassifizierung && (
            <Select
              className='sperrigkeit'
              headerTitle='Klassifizierung'
              onChangeHandler={props.setSperrigkeit}
              selectedOptionId={props.auftragserfassung.sperrigkeit}
              selectData={toSelectOptions(
                props.sperrigkeitAuswahlListe,
                'bezkurz',
                false,
                true
              )}
            />
          )}
          {props.userSession.isMetro && (
            <Select
              className='metrokennung'
              headerTitle='Metro-Kennung'
              onChangeHandler={props.setMetrokennung}
              selectedOptionId={props.auftragserfassung.metrokennung}
              selectData={toSelectOptions(
                props.metrokennungAuswahlListe,
                'bezeichnung',
                false,
                true
              )}
            />
          )}
        </Form>
        {props.isTauschgeraete && <Tauschgeraete />}
        {props.isZusaetzlicheLademittel && (
          <GridCellWrapper
            classes='tauschgeraete'
            label='zusätzliche Lademittel'
          >
            <div id='tausch'>
              <span>erfasst: </span>
              <SliderCheckbox
                disabled={false}
                value={
                  zusLademittelIsEmpty(
                    props.auftragserfassung.currentZusLademittel[0]
                  )
                    ? 0
                    : 1
                }
                onChangeHandler={() => setShowModalZusLademittel(true)}
                labelActive={'Ja'}
                labelInactive={'Nein'}
              />
            </div>
          </GridCellWrapper>
        )}
      </GridCellWrapper>
      <Modal
        show={showModalZusLademittel}
        closeHandler={closeZusLademittel}
        closeByOutsideClick={false}
        titel={'zusätzliche Lademittel'}
        height={'500px'}
        width={'900px'}
        description={'Erfassung zusätzlicher Lademittel'}
      >
        <Zuslademittel close={closeZusLademittel} />
      </Modal>
    </Fragment>
  );
};

const mapStateToProps = (state: StateModel) => ({
  resetToggle: state.Auftragserfassung.resetToggle,
  auftragserfassung: state.Auftragserfassung,
  userSession: state.UserSession,
  terminkennzeichenAuswahlListe: state.Stammdaten.terminkennzeichen,
  frankaturAuswahlListe: state.Stammdaten.frankaturen,
  verkehrsartAuswahlListe: state.Stammdaten.verkehrsarten,
  metrokennungAuswahlListe: state.Stammdaten.metrokennungen,
  sperrigkeitAuswahlListe: state.Stammdaten.sperrigkeiten,
  isTauschgeraete: state.Config.isTauschgeraete,
  isZusaetzlicheLademittel: state.Config.isZusaetzlicheLademittel,
  config: state.Config,
});

export default connect(mapStateToProps, {
  getTerminkennzeichen,
  setTerminkennzeichen,
  setModalConfig,
  resetModalConfig,
  getFrankaturen,
  setFrankatur,
  getVerkehrsarten,
  setVerkehrsart,
  setMetrokennung,
  getMetrokennungen,
  getSperrigkeiten,
  setSperrigkeit,
})(Allgemein);
